import script from "./AddOfflineBankAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddOfflineBankAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddOfflineBankAccountPage.vue?vue&type=style&index=0&id=02058746&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02058746"]])

export default __exports__